module.exports = __webpack_public_path__ + "img/POLY_12.2.26.jpg";